import { FeatureLike } from "ol/Feature";
import { Fill, Stroke, Style } from "ol/style";

export const PtBoundariesStyles = (
  feature: FeatureLike,
  resolution: number,
) => {
  return new Style({
    fill: new Fill({
      color: "rgba(0, 123, 255, 0.2)",
    }),
    stroke: new Stroke({
      color: "#003366",
      width: 0.8,
    }),
  });
};

export const PtBoundariesStylesDarkMode = (
  feature: FeatureLike,
  resolution: number,
) => {
  return new Style({
    fill: new Fill({
      color: "rgba(0, 123, 255, 0.2)",
    }),
    stroke: new Stroke({
      color: "#fcfcfcff",
      width: 0.8,
    }),
  });
};
